'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ref;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var base = _react2.default.createElement(_radium.Style, {
  name: 'base',
  scopeSelector: _constants.QUERY_SELECTORS.PRESENTATION,
  rules: (_ref = {
    position: 'relative',
    overflow: 'hidden'

  }, _defineProperty(_ref, _constants.QUERY_SELECTORS.SCALE, {
    position: 'relative',
    width: '100%',
    height: '100%'
  }), _defineProperty(_ref, _constants.QUERY_SELECTORS.SLIDES, {
    width: '100%',
    height: '100%',
    overflow: 'hidden'
  }), _defineProperty(_ref, _constants.QUERY_SELECTORS.SLIDE, {
    boxSizing: 'border-box',
    width: '100%',
    height: '100%'
  }), _defineProperty(_ref, _constants.QUERY_SELECTORS.COVER, {
    boxSizing: 'border-box',
    width: '100%',
    height: '100%'
  }), _defineProperty(_ref, _constants.QUERY_SELECTORS.H1, {
    margin: 0,
    padding: 0
  }), _defineProperty(_ref, _constants.QUERY_SELECTORS.H2, {
    margin: 0,
    padding: 0
  }), _defineProperty(_ref, _constants.QUERY_SELECTORS.P, {
    margin: 0,
    padding: 0
  }), _ref)
});

exports.default = base;


/*****************
 ** WEBPACK FOOTER
 ** ../lib/themes/base.js
 ** module id = 138
 ** module chunks = 0
 **/